import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import type { ReportScopeNote } from './financeApi'

export function OpenPeriodsAlert({ note }: { note: ReportScopeNote | undefined }) {
  const { t } = useTranslation()
  const open = note?.periods.filter((period) => period.state === 'OPEN') ?? []
  if (open.length === 0) return null

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
      message={t('finance.openPeriods.title', { periods: open.map((p) => p.code).join(', ') })}
      description={t('finance.openPeriods.hint')}
    />
  )
}
